import React, { ReactElement } from 'react';
import { createFormattedDateString } from '@/lib/util';
import DOMPurify from 'dompurify';
import CommentsType from '@/modules/types/comments';
import {
  Col,
  Heading,
  Row,
  Text,
  NativeSelect,
  FormItem,
  Button,
  Dialog,
  DeleteOutlinedIcon,
} from 'elmo-elements';
import { CommentStatus } from '@/modules/types/comments/commentStatus.enum';

interface CommentsPropsType {
  title: string;
  comment: CommentsType;
  onDelete: (id: string) => void;
  onUpdate: (status: number) => void;
}

const commentStatuses = [
  {
    label: 'New',
    value: CommentStatus.NEW,
  },
  {
    label: 'Rejected',
    value: CommentStatus.REJECTED,
  },
  {
    label: 'Complete',
    value: CommentStatus.COMPLETE,
  },
];

export const Comment = ({
  title,
  comment,
  onDelete,
  onUpdate,
}: CommentsPropsType): ReactElement => {
  const sanitizeHTML = DOMPurify.sanitize;

  return (
    <Row className="m-3 p-3 b-btm-gray">
      <Col span={16}>
        <Heading>{title}</Heading>
        <Text size="sm">{createFormattedDateString(comment.createdAt)}</Text>
        <Text>
          <div
            className="mt-4"
            role="article"
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(comment.comment),
            }}
          />
        </Text>
      </Col>
      <Col span={8}>
        <FormItem label="Status">
          <Row alignContent="center">
            <Col span={16}>
              <NativeSelect
                onChange={(e) => {
                  const status = +e;
                  onUpdate(status);
                }}
                value={comment.status}
              >
                {commentStatuses.map((commentStatus) => (
                  <NativeSelect.Option
                    key={commentStatus.label}
                    label={commentStatus.label}
                    value={commentStatus.value}
                  />
                ))}
              </NativeSelect>
            </Col>
            <Col isAuto>
              <Button
                className="b-btm-gray"
                type="danger"
                onClick={() => {
                  Dialog.confirm({
                    title: 'Confirm deletion',
                    content:
                      'Are you sure you want to delete this comment? This action cannot be undone.',
                    onOk() {
                      onDelete(comment.id);
                    },
                    okLabel: 'Confirm',
                  });
                }}
              >
                <DeleteOutlinedIcon />
              </Button>
            </Col>
          </Row>
        </FormItem>
      </Col>
    </Row>
  );
};

export default Comment;
